import { TStatistics } from "./Statistics";

export interface IAgePriceMatrix {
  childPrice: number;
  youngPrice: number;
  discountedPrice: number;
  fullPrice: number;
}

export type EditionPricingPeriod = 'earlyBird' | 'regular' | 'atLocation';

export interface IEditionPricing {
  earlyBird: IAgePriceMatrix;
  regular: IAgePriceMatrix;
  atLocation: IAgePriceMatrix;
}

export interface IEditionCompetition {
  competitionId: string;
  distances: string[];
}

export interface IBaseEdition {
  canShowResults?: boolean;
  isSignupOpen?: boolean;
  childPrice: number;
  /** Inclusive max age for child price tier (default 6). */
  childMaxAge?: number;
  competitions: IEditionCompetition[];
  date: Date;
  discountedPrice: number;
  /** End of early-bird period; optional on legacy editions. */
  earlyBirdEndsAt?: Date;
  fullPrice: number;
  /** Flat group check-in price; not part of period matrices. */
  groupPrice?: number;
  /** Period matrices; optional on legacy — normalize from flat fields. */
  pricing?: IEditionPricing;
  signupDeadline: Date;
  year: number;
  youngPrice: number;
}

export type IFormEdition = IBaseEdition;

export interface IEdition extends IBaseEdition {
  id: string;
  checkinsByPrice?: {
    [key: string]: number;
  };
  statistics?: TStatistics;
  totalPrice?: number;
}

/** Ensures `competitions` is always an array (API may omit it when empty). */
export function normalizeEdition<T extends Partial<IBaseEdition>>(edition: T): T & IBaseEdition {
  return {
    ...edition,
    competitions: edition.competitions ?? [],
  } as T & IBaseEdition;
}

export function normalizeEditions(editions: IEdition[]): IEdition[] {
  return editions.map(e => normalizeEdition(e) as IEdition);
}
